import { createFileRoute } from '@tanstack/react-router';

import { CrossBorderReportPage } from '@/features/nis2/pages/CrossBorderReportPage';

export const Route = createFileRoute('/_authenticated/nis2/reports/cross-border')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <CrossBorderReportPage />
      </div>
    </div>
  );
}
